module.exports = __webpack_public_path__ + "img/actors-home-en.c857e3b5.jpg";